const translations = {
  en: {
    lang: "English",
    langCode: "en",
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      area: "Service Area",
      reviews: "Reviews",
      contact: "Contact",
      callNow: "Call Now",
    },
    hero: {
      title: "PREMIUM AUTO CARE",
      titleHighlight: "FOR GREATER BOSTON",
      subtitle: "Expert diagnostics, precision repair, and multilingual service — your trusted auto shop in North Reading, MA.",
      callNow: "Call Now",
      textUs: "Text Us",
      whatsapp: "WhatsApp",
      schedule: "Schedule Service",
    },
    trust: {
      title: "WHY CHOOSE US",
      fast: "Fast Service",
      fastDesc: "Same-day service available for most repairs. We value your time.",
      fair: "Fair Pricing",
      fairDesc: "Transparent pricing with no hidden fees. Honest estimates every time.",
      precise: "Precise Diagnostics",
      preciseDesc: "State-of-the-art diagnostic equipment for accurate problem identification.",
      multilingual: "Multilingual Support",
      multilingualDesc: "We speak English, Portuguese, and Spanish to serve our diverse community.",
    },
    services: {
      title: "OUR SERVICES",
      subtitle: "Comprehensive auto care from routine maintenance to complex repairs",
      cta: "Schedule This Service",
      items: [
        {
          title: "General Repair",
          description: "Complete vehicle repair services for all makes and models. From minor fixes to major overhauls.",
          benefits: "All makes & models, Certified technicians, Warranty on parts",
        },
        {
          title: "Engine Diagnostics",
          description: "Advanced computer diagnostics to identify engine issues quickly and accurately.",
          benefits: "OBD-II scanning, Performance analysis, Check engine light diagnosis",
        },
        {
          title: "Brake Service",
          description: "Complete brake system inspection, repair, and replacement for safe stopping.",
          benefits: "Pad & rotor replacement, Brake fluid flush, ABS diagnostics",
        },
        {
          title: "Oil Change",
          description: "Quick and professional oil change service with premium synthetic and conventional options.",
          benefits: "Synthetic & conventional, Filter replacement, Multi-point inspection",
        },
        {
          title: "Transmission",
          description: "Expert transmission diagnostics, repair, and maintenance for smooth shifting.",
          benefits: "Fluid service, Clutch repair, Automatic & manual",
        },
        {
          title: "Suspension & Steering",
          description: "Alignment, strut replacement, and steering system repair for a smooth ride.",
          benefits: "Wheel alignment, Strut & shock replacement, Power steering repair",
        },
        {
          title: "Electrical Systems",
          description: "Battery testing, alternator repair, wiring diagnostics, and electrical component service.",
          benefits: "Battery replacement, Alternator repair, Wiring diagnostics",
        },
        {
          title: "AC & Heating",
          description: "Climate control system inspection, repair, and recharge for year-round comfort.",
          benefits: "AC recharge, Heater core repair, Climate diagnostics",
        },
        {
          title: "Preventive Maintenance",
          description: "Scheduled maintenance services to keep your vehicle running at peak performance.",
          benefits: "Tune-ups, Fluid services, Belt & hose inspection",
        },
      ],
    },
    about: {
      title: "ABOUT SOUSA AUTO SERVICE",
      p1: "SousA Auto Service Inc is a premium automotive repair shop located at 216 Main St, North Reading, MA. We specialize in delivering dealership-quality service at independent shop prices.",
      p2: "Our team of certified technicians brings years of experience in servicing all makes and models. We pride ourselves on honest diagnostics, transparent pricing, and fast turnaround times.",
      p3: "Serving the Greater Boston area, we are committed to providing multilingual support in English, Portuguese, and Spanish — because great service should have no language barriers.",
      hours: "Business Hours",
      monFri: "Mon – Fri",
      monFriTime: "8:00 AM – 6:00 PM",
      sat: "Saturday",
      satTime: "8:00 AM – 1:00 PM",
      sun: "Sunday",
      sunTime: "Closed",
    },
    area: {
      title: "SERVICE AREA",
      subtitle: "Proudly serving the Greater Boston community",
      description: "SousA Auto Service is conveniently located in North Reading, MA, providing premium auto repair services to drivers across the Greater Boston metropolitan area. Whether you need routine maintenance or complex repairs, our shop is easily accessible from all surrounding communities.",
      seoText: "Looking for a trusted auto repair shop near Boston? SousA Auto Service provides expert mechanic services including brake repair, oil changes, engine diagnostics, and more. Conveniently located in North Reading, we serve drivers from Boston, Cambridge, Somerville, and throughout the Greater Boston area.",
    },
    reviews: {
      title: "WHAT OUR CUSTOMERS SAY",
      subtitle: "Real experiences from our valued clients",
      items: [
        { name: "Michael R.", city: "North Reading", rating: 5, text: "Best mechanic I've ever been to. Honest, fast, and fair pricing. They diagnosed my engine issue in minutes when other shops couldn't figure it out for days." },
        { name: "Ana S.", city: "Woburn", rating: 5, text: "Excelente servico! Falam portugues e me sentiram muito bem atendida. Recomendo para todos!" },
        { name: "Carlos M.", city: "Somerville", rating: 5, text: "Servicio increible. Hablan espanol y son muy profesionales. Arreglaron mi transmision rapido y a buen precio." },
        { name: "David K.", city: "Reading", rating: 5, text: "Had my brakes done here. Quick turnaround, competitive price, and they even showed me the worn parts. Transparent and trustworthy." },
        { name: "Jennifer L.", city: "Wakefield", rating: 5, text: "They took great care of my car during its routine maintenance. Very professional team and the waiting area was clean and comfortable." },
        { name: "Roberto F.", city: "Medford", rating: 5, text: "Finally found a shop that speaks my language and does quality work. Been coming here for a year now and never disappointed." },
      ],
    },
    contact: {
      title: "SCHEDULE YOUR SERVICE",
      subtitle: "Fill out the form below and we'll get back to you shortly",
      name: "Full Name",
      phone: "Phone Number",
      email: "Email Address",
      vehicleMake: "Vehicle Make",
      vehicleModel: "Vehicle Model",
      year: "Year",
      serviceNeeded: "Service Needed",
      preferredDate: "Preferred Date",
      message: "Additional Message",
      submit: "Submit Request",
      success: "Your request has been submitted! We'll contact you shortly.",
      required: "This field is required",
      callUs: "Call Us",
      textUs: "Text Us",
      whatsapp: "WhatsApp Us",
      emailUs: "Email Us",
      visitUs: "Visit Us",
      address: "216 Main St, North Reading, MA",
      selectService: "Select a service...",
      selectDate: "Pick a date",
    },
    footer: {
      tagline: "Premium Auto Care for Greater Boston",
      quickLinks: "Quick Links",
      contactInfo: "Contact Info",
      hours: "Business Hours",
      rights: "All rights reserved.",
    },
    languageSelect: {
      title: "SELECT YOUR LANGUAGE",
      subtitle: "SELECIONE SEU IDIOMA | SELECCIONE SU IDIOMA",
    },
  },
  pt: {
    lang: "Portugues",
    langCode: "pt",
    nav: {
      home: "Inicio",
      services: "Servicos",
      about: "Sobre",
      area: "Area de Atendimento",
      reviews: "Avaliacoes",
      contact: "Contato",
      callNow: "Ligue Agora",
    },
    hero: {
      title: "SERVICO AUTOMOTIVO",
      titleHighlight: "PREMIUM EM BOSTON",
      subtitle: "Diagnostico especializado, reparo de precisao e atendimento multilingue — sua oficina de confianca em North Reading, MA.",
      callNow: "Ligue Agora",
      textUs: "Envie SMS",
      whatsapp: "WhatsApp",
      schedule: "Agende um Servico",
    },
    trust: {
      title: "POR QUE NOS ESCOLHER",
      fast: "Servico Rapido",
      fastDesc: "Servico no mesmo dia disponivel para a maioria dos reparos. Valorizamos seu tempo.",
      fair: "Preco Justo",
      fairDesc: "Precos transparentes sem taxas ocultas. Orcamentos honestos sempre.",
      precise: "Diagnostico Preciso",
      preciseDesc: "Equipamentos de diagnostico de ultima geracao para identificacao precisa de problemas.",
      multilingual: "Suporte Multilingue",
      multilingualDesc: "Falamos Ingles, Portugues e Espanhol para atender nossa comunidade diversa.",
    },
    services: {
      title: "NOSSOS SERVICOS",
      subtitle: "Cuidado automotivo completo, de manutencao rotineira a reparos complexos",
      cta: "Agende Este Servico",
      items: [
        { title: "Reparo Geral", description: "Servicos completos de reparo para todas as marcas e modelos. De consertos menores a revisoes maiores.", benefits: "Todas as marcas, Tecnicos certificados, Garantia em pecas" },
        { title: "Diagnostico de Motor", description: "Diagnostico computadorizado avancado para identificar problemas no motor rapidamente.", benefits: "Escaneamento OBD-II, Analise de desempenho, Diagnostico de luz do motor" },
        { title: "Servico de Freios", description: "Inspecao, reparo e substituicao completa do sistema de freios.", benefits: "Substituicao de pastilhas e discos, Troca de fluido, Diagnostico ABS" },
        { title: "Troca de Oleo", description: "Troca de oleo rapida e profissional com opcoes sinteticas e convencionais.", benefits: "Sintetico e convencional, Troca de filtro, Inspecao multiponto" },
        { title: "Transmissao", description: "Diagnostico, reparo e manutencao especializada de transmissao.", benefits: "Servico de fluido, Reparo de embreagem, Automatica e manual" },
        { title: "Suspensao e Direcao", description: "Alinhamento, substituicao de amortecedores e reparo do sistema de direcao.", benefits: "Alinhamento, Substituicao de amortecedores, Reparo de direcao hidraulica" },
        { title: "Sistemas Eletricos", description: "Teste de bateria, reparo de alternador e diagnostico de fiacao.", benefits: "Substituicao de bateria, Reparo de alternador, Diagnostico de fiacao" },
        { title: "Ar Condicionado e Aquecimento", description: "Inspecao, reparo e recarga do sistema de climatizacao.", benefits: "Recarga de AC, Reparo do nucleo de aquecimento, Diagnostico climatico" },
        { title: "Manutencao Preventiva", description: "Servicos de manutencao programada para manter seu veiculo em perfeito funcionamento.", benefits: "Tune-ups, Servicos de fluidos, Inspecao de correias" },
      ],
    },
    about: {
      title: "SOBRE A SOUSA AUTO SERVICE",
      p1: "A SousA Auto Service Inc e uma oficina automotiva premium localizada na 216 Main St, North Reading, MA. Somos especializados em entregar servico de qualidade de concessionaria a precos de oficina independente.",
      p2: "Nossa equipe de tecnicos certificados traz anos de experiencia no servico de todas as marcas e modelos. Temos orgulho em diagnosticos honestos, precos transparentes e tempo de retorno rapido.",
      p3: "Atendendo a regiao da Grande Boston, estamos comprometidos em fornecer suporte multilingue em Ingles, Portugues e Espanhol — porque um otimo servico nao deve ter barreiras linguisticas.",
      hours: "Horario de Funcionamento",
      monFri: "Seg – Sex",
      monFriTime: "8:00 – 18:00",
      sat: "Sabado",
      satTime: "8:00 – 13:00",
      sun: "Domingo",
      sunTime: "Fechado",
    },
    area: {
      title: "AREA DE ATENDIMENTO",
      subtitle: "Orgulhosamente servindo a comunidade da Grande Boston",
      description: "A SousA Auto Service esta convenientemente localizada em North Reading, MA, fornecendo servicos de reparo automotivo premium para motoristas em toda a area metropolitana da Grande Boston.",
      seoText: "Procurando uma oficina mecanica confiavel perto de Boston? A SousA Auto Service oferece servicos especializados incluindo reparo de freios, troca de oleo, diagnostico de motor e muito mais.",
    },
    reviews: {
      title: "O QUE NOSSOS CLIENTES DIZEM",
      subtitle: "Experiencias reais de nossos clientes",
      items: [
        { name: "Michael R.", city: "North Reading", rating: 5, text: "Melhor mecanico que ja fui. Honesto, rapido e preco justo. Diagnosticaram o problema do meu motor em minutos." },
        { name: "Ana S.", city: "Woburn", rating: 5, text: "Excelente servico! Falam portugues e me senti muito bem atendida. Recomendo para todos!" },
        { name: "Carlos M.", city: "Somerville", rating: 5, text: "Servico incrivel. Falam espanhol e sao muito profissionais. Consertaram minha transmissao rapidamente." },
        { name: "David K.", city: "Reading", rating: 5, text: "Fiz os freios aqui. Rapido, preco competitivo, e ainda me mostraram as pecas gastas. Transparentes e confiaveis." },
        { name: "Jennifer L.", city: "Wakefield", rating: 5, text: "Cuidaram muito bem do meu carro na manutencao de rotina. Equipe muito profissional." },
        { name: "Roberto F.", city: "Medford", rating: 5, text: "Finalmente encontrei uma oficina que fala minha lingua e faz trabalho de qualidade. Venho aqui ha um ano." },
      ],
    },
    contact: {
      title: "AGENDE SEU SERVICO",
      subtitle: "Preencha o formulario abaixo e entraremos em contato em breve",
      name: "Nome Completo",
      phone: "Telefone",
      email: "Email",
      vehicleMake: "Marca do Veiculo",
      vehicleModel: "Modelo do Veiculo",
      year: "Ano",
      serviceNeeded: "Servico Necessario",
      preferredDate: "Data Preferida",
      message: "Mensagem Adicional",
      submit: "Enviar Solicitacao",
      success: "Sua solicitacao foi enviada! Entraremos em contato em breve.",
      required: "Este campo e obrigatorio",
      callUs: "Ligue Para Nos",
      textUs: "Envie SMS",
      whatsapp: "WhatsApp",
      emailUs: "Envie Email",
      visitUs: "Visite-nos",
      address: "216 Main St, North Reading, MA",
      selectService: "Selecione um servico...",
      selectDate: "Escolha uma data",
    },
    footer: {
      tagline: "Servico Automotivo Premium para Grande Boston",
      quickLinks: "Links Rapidos",
      contactInfo: "Informacoes de Contato",
      hours: "Horario de Funcionamento",
      rights: "Todos os direitos reservados.",
    },
    languageSelect: {
      title: "SELECIONE SEU IDIOMA",
      subtitle: "SELECT YOUR LANGUAGE | SELECCIONE SU IDIOMA",
    },
  },
  es: {
    lang: "Espanol",
    langCode: "es",
    nav: {
      home: "Inicio",
      services: "Servicios",
      about: "Acerca de",
      area: "Area de Servicio",
      reviews: "Resenas",
      contact: "Contacto",
      callNow: "Llamar Ahora",
    },
    hero: {
      title: "SERVICIO AUTOMOTRIZ",
      titleHighlight: "PREMIUM EN BOSTON",
      subtitle: "Diagnostico experto, reparacion de precision y servicio multilingue — su taller de confianza en North Reading, MA.",
      callNow: "Llamar Ahora",
      textUs: "Enviar SMS",
      whatsapp: "WhatsApp",
      schedule: "Agendar Servicio",
    },
    trust: {
      title: "POR QUE ELEGIRNOS",
      fast: "Servicio Rapido",
      fastDesc: "Servicio el mismo dia disponible para la mayoria de reparaciones. Valoramos su tiempo.",
      fair: "Precio Justo",
      fairDesc: "Precios transparentes sin cargos ocultos. Presupuestos honestos siempre.",
      precise: "Diagnostico Preciso",
      preciseDesc: "Equipos de diagnostico de ultima generacion para identificacion precisa de problemas.",
      multilingual: "Soporte Multilingue",
      multilingualDesc: "Hablamos Ingles, Portugues y Espanol para atender a nuestra comunidad diversa.",
    },
    services: {
      title: "NUESTROS SERVICIOS",
      subtitle: "Cuidado automotriz completo, desde mantenimiento rutinario hasta reparaciones complejas",
      cta: "Agendar Este Servicio",
      items: [
        { title: "Reparacion General", description: "Servicios completos de reparacion para todas las marcas y modelos.", benefits: "Todas las marcas, Tecnicos certificados, Garantia en piezas" },
        { title: "Diagnostico de Motor", description: "Diagnostico computarizado avanzado para identificar problemas del motor rapidamente.", benefits: "Escaneo OBD-II, Analisis de rendimiento, Diagnostico de luz del motor" },
        { title: "Servicio de Frenos", description: "Inspeccion, reparacion y reemplazo completo del sistema de frenos.", benefits: "Reemplazo de pastillas y rotores, Cambio de liquido, Diagnostico ABS" },
        { title: "Cambio de Aceite", description: "Cambio de aceite rapido y profesional con opciones sinteticas y convencionales.", benefits: "Sintetico y convencional, Cambio de filtro, Inspeccion multipunto" },
        { title: "Transmision", description: "Diagnostico, reparacion y mantenimiento especializado de transmision.", benefits: "Servicio de fluidos, Reparacion de embrague, Automatica y manual" },
        { title: "Suspension y Direccion", description: "Alineacion, reemplazo de amortiguadores y reparacion del sistema de direccion.", benefits: "Alineacion de ruedas, Reemplazo de amortiguadores, Reparacion de direccion" },
        { title: "Sistemas Electricos", description: "Prueba de bateria, reparacion de alternador y diagnostico de cableado.", benefits: "Reemplazo de bateria, Reparacion de alternador, Diagnostico de cableado" },
        { title: "Aire Acondicionado y Calefaccion", description: "Inspeccion, reparacion y recarga del sistema de climatizacion.", benefits: "Recarga de AC, Reparacion del nucleo de calefaccion, Diagnostico" },
        { title: "Mantenimiento Preventivo", description: "Servicios de mantenimiento programado para mantener su vehiculo en optimo rendimiento.", benefits: "Afinaciones, Servicios de fluidos, Inspeccion de correas" },
      ],
    },
    about: {
      title: "ACERCA DE SOUSA AUTO SERVICE",
      p1: "SousA Auto Service Inc es un taller automotriz premium ubicado en 216 Main St, North Reading, MA. Nos especializamos en brindar servicio de calidad de concesionario a precios de taller independiente.",
      p2: "Nuestro equipo de tecnicos certificados aporta anos de experiencia en el servicio de todas las marcas y modelos. Nos enorgullecemos de diagnosticos honestos, precios transparentes y tiempos de entrega rapidos.",
      p3: "Sirviendo al area de Greater Boston, estamos comprometidos a brindar soporte multilingue en Ingles, Portugues y Espanol — porque un gran servicio no debe tener barreras idiomaticas.",
      hours: "Horario de Atencion",
      monFri: "Lun – Vie",
      monFriTime: "8:00 AM – 6:00 PM",
      sat: "Sabado",
      satTime: "8:00 AM – 1:00 PM",
      sun: "Domingo",
      sunTime: "Cerrado",
    },
    area: {
      title: "AREA DE SERVICIO",
      subtitle: "Orgullosamente sirviendo a la comunidad de Greater Boston",
      description: "SousA Auto Service esta convenientemente ubicado en North Reading, MA, brindando servicios de reparacion automotriz premium a conductores en toda el area metropolitana de Greater Boston.",
      seoText: "Buscando un taller mecanico confiable cerca de Boston? SousA Auto Service ofrece servicios expertos incluyendo reparacion de frenos, cambio de aceite, diagnostico de motor y mas.",
    },
    reviews: {
      title: "LO QUE DICEN NUESTROS CLIENTES",
      subtitle: "Experiencias reales de nuestros clientes",
      items: [
        { name: "Michael R.", city: "North Reading", rating: 5, text: "El mejor mecanico al que he ido. Honesto, rapido y precios justos. Diagnosticaron el problema de mi motor en minutos." },
        { name: "Ana S.", city: "Woburn", rating: 5, text: "Excelente servicio! Hablan portugues y me senti muy bien atendida. Lo recomiendo a todos!" },
        { name: "Carlos M.", city: "Somerville", rating: 5, text: "Servicio increible. Hablan espanol y son muy profesionales. Arreglaron mi transmision rapido y a buen precio." },
        { name: "David K.", city: "Reading", rating: 5, text: "Me hicieron los frenos aqui. Rapido, precio competitivo, y me mostraron las piezas gastadas. Transparentes y confiables." },
        { name: "Jennifer L.", city: "Wakefield", rating: 5, text: "Cuidaron muy bien mi auto en el mantenimiento de rutina. Equipo muy profesional." },
        { name: "Roberto F.", city: "Medford", rating: 5, text: "Finalmente encontre un taller que habla mi idioma y hace trabajo de calidad. Llevo un ano viniendo aqui." },
      ],
    },
    contact: {
      title: "AGENDE SU SERVICIO",
      subtitle: "Complete el formulario y nos pondremos en contacto pronto",
      name: "Nombre Completo",
      phone: "Telefono",
      email: "Correo Electronico",
      vehicleMake: "Marca del Vehiculo",
      vehicleModel: "Modelo del Vehiculo",
      year: "Ano",
      serviceNeeded: "Servicio Necesario",
      preferredDate: "Fecha Preferida",
      message: "Mensaje Adicional",
      submit: "Enviar Solicitud",
      success: "Su solicitud ha sido enviada! Nos pondremos en contacto pronto.",
      required: "Este campo es obligatorio",
      callUs: "Llamenos",
      textUs: "Envie SMS",
      whatsapp: "WhatsApp",
      emailUs: "Envie Email",
      visitUs: "Visitenos",
      address: "216 Main St, North Reading, MA",
      selectService: "Seleccione un servicio...",
      selectDate: "Elija una fecha",
    },
    footer: {
      tagline: "Servicio Automotriz Premium para Greater Boston",
      quickLinks: "Enlaces Rapidos",
      contactInfo: "Informacion de Contacto",
      hours: "Horario de Atencion",
      rights: "Todos los derechos reservados.",
    },
    languageSelect: {
      title: "SELECCIONE SU IDIOMA",
      subtitle: "SELECT YOUR LANGUAGE | SELECIONE SEU IDIOMA",
    },
  },
};

export default translations;
